import { QUESTION_TYPES, type MessageType, type OptionType } from 'types/sapa';
import { InfoQuestion } from '../InfoQuestion';
import { MultipleQuestion } from '../MultipleQuestion';
import { SingleQuestion } from '../SingleQuestion';

export interface SapaMessageItemProps {
  message: MessageType & {
    options?: OptionType[];
    questionId?: string;
    hasTextInput?: boolean;
    textInputLabel?: string;
  };
}

export const MessageTypes = {
  [QUESTION_TYPES.SINGLE]: SingleQuestion,
  [QUESTION_TYPES.MULTIPLE]: MultipleQuestion,
  [QUESTION_TYPES.INFO]: InfoQuestion,
};
